import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";
import {renderBorderColor} from "../../../controllers/SystemOptionProposalController";

export default function DetailedCourseExampleAnswerText({exampleAnswer}) {
    // Used in DetailedCourseLevelAKnowledgeExample to display
    // exampleAnswer text

    // BUILD
    if (isNullOrUndefined(exampleAnswer))
        return null
    return (
        <div className="w-full flex justify-center mt-[12px]">
            <div className={`border-1 rounded-[8px] py-[6px] px-[12px] ${renderBorderColor(true)}`}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                        <span className="font-bold text-white text-[18px]">
                            {exampleAnswer}
                        </span>
                    </MathJax>
                </MathJaxContext>
            </div>
        </div>
    );
}